// extracted by mini-css-extract-plugin
export default {"videoPreview":"leQcd","active":"YIlhs","posterImage":"GZD45","playIcon":"SpZwj","cnImage":"KBxxZ","container":"rKJ0W","video":"NjyFY"};